<template>
  <div class="c-convincing-deactivating-list">
    <h6 class="title is-spaced">Tudo bem ;)</h6>

    <p class="subtitle is-medium">
      Se ficar com alguma dúvida na hora de criar a sua lista, conte com a nossa
      equipe para te ajudar
    </p>

    <p class="informative">
      Sua lista foi desativada e os presentes não serão exibidos no site para os
      convidados.
    </p>

    <button
      @click="$emit('disableList')"
      type="button"
      class="button is-primary"
    >
      Concluir
    </button>
  </div>
</template>

<script>
export default {
  data() {
    return {}
  },

  methods: {},
}
</script>

<style lang="scss">
.c-convincing-deactivating-list {
  .informative {
    margin: 48px 0 40px;
    font-size: 18px;
    color: $primary;
  }
}
</style>
